import React, { useEffect } from "react";
import "./App.css";
import "./assets/scss/theme.scss";

import Router from "Routes";
import { ToastContainer } from "react-toastify";
// import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import "react-toastify/dist/ReactToastify.css";
import { queryClient, persister } from "utils";
import { useSelector } from "hooks/useSelector";
import { getRefreshToken } from "services";
import { setToken, setLoggedInAt } from "slices/auth/login/reducer";
import { useDispatch } from "react-redux";

function App() {
  const dispatch: any = useDispatch();

  const { loggedInAt, refreshToken, accessToken } = useSelector(
    (state) => state.Login
  );

  useEffect(() => {
    if (loggedInAt && refreshToken && accessToken) {
      const now = Date.now();
      const timeSinceLogin = now - Number(loggedInAt);
      const timeToRefresh = Math.max(600000 - timeSinceLogin, 0);

      const fetchRefreshToken = async () => {
        try {
          const res = await getRefreshToken(refreshToken);

          if (res) {
            dispatch(
              setToken({
                accessToken: res.access_token,
                refreshToken: res.refresh_token,
              })
            );
            dispatch(setLoggedInAt(Date.now()));
          }
        } catch (error) {
          console.error("Failed", error);
        } finally {
        }
      };

      const timeout = setTimeout(fetchRefreshToken, timeToRefresh);
      return () => clearTimeout(timeout);
    }
  }, [dispatch, loggedInAt, refreshToken, accessToken]);
  return (
    <>
      <PersistQueryClientProvider
        client={queryClient}
        persistOptions={{ persister }}
      >
        <>
          {/* <ReactQueryDevtools initialIsOpen={false} /> */}

          <Router />
          <ToastContainer />
        </>
      </PersistQueryClientProvider>
    </>
  );
}

export default App;
